import {
	MODULE_NAME,
	MESSAGE_STATE,
	SET_TOAST_MESSAGES
} from './toast-mutation-types';
import { generateRandomNumber } from '@/utils/function';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		toastMessages: []
	},
	mutations: {
		[SET_TOAST_MESSAGES](state, obj) {
			const { data } = obj;
			if (obj.push) {
				state.toastMessages.push(data);
			} else {
				state.toastMessages = state.toastMessages.filter(
					t => t.toastId !== data.toastId
				);
			}
		}
	},
	actions: {
		show({ commit }, obj) {
			commit(SET_TOAST_MESSAGES, { data: obj, push: true });
		},
		hide({ commit }, obj) {
			commit(SET_TOAST_MESSAGES, { data: obj, push: false });
		},
		push({ commit }, obj) {
			if (obj.message && !obj.message.includes('499')) {
				commit(SET_TOAST_MESSAGES, {
					data: Object.assign(obj, {
						toastId: `${generateRandomNumber(5)}`
					}),
					push: true
				});
			}
		}
	},
	getters: {
		[MESSAGE_STATE]: state => state[MESSAGE_STATE]
	}
};
